'use client'

import { useEffect } from 'react'

import { syneriseRecommendationView } from 'lib/synerise/events'
import { RecommendationMetadataType } from 'lib/synerise/types'
import { useTriggerOnce } from 'shared/hooks/useTriggerOnce'

type UseSyneriseRecommendationViewProps = {
  recommendationMetadata?: RecommendationMetadataType
  items: string[]
  shouldTrigger: boolean // e.g. inView && sessionLoaded && productsNotEmpty
}

// Hook to trigger Synerise recommendation view event only when items and metadata is present, once per page visit
export function useSyneriseRecommendationView({
  recommendationMetadata,
  items,
  shouldTrigger
}: UseSyneriseRecommendationViewProps) {
  const [triggerOnce] = useTriggerOnce()

  useEffect(() => {
    const { campaignId, correlationId } = recommendationMetadata || {}

    if (!shouldTrigger) return
    if (!campaignId || !correlationId || items.length === 0) return

    triggerOnce(() => {
      syneriseRecommendationView({
        campaignId,
        correlationId,
        items
      })
    })
  }, [shouldTrigger, recommendationMetadata, items, triggerOnce])
}
